import {DATA_TYPES} from '../../constants/constants'
import {DEFAULT_VARIABLES_TYPES, SUPPORTED_VARIABLE_TYPES as supportedCssVariableTypes} from './cssVariableTypes'
export const VARIABLES_LIST_TYPE = 'VariablesList'

export const NAMESPACES_SUPPORTING_VARIABLES = new Set([DATA_TYPES.layout, DATA_TYPES.theme, DATA_TYPES.variables])

export const VARIABLE_TYPES = {
    CSS: DEFAULT_VARIABLES_TYPES
}

export const SUPPORTED_VARIABLE_TYPES = {
    CSS: supportedCssVariableTypes
}
